import { render } from "./HeaderBirthday.vue?vue&type=template&id=2f23dd8b&scoped=true"
import script from "./HeaderBirthday.vue?vue&type=script&lang=js"
export * from "./HeaderBirthday.vue?vue&type=script&lang=js"

import "./HeaderBirthday.vue?vue&type=style&index=0&id=2f23dd8b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f23dd8b"]])

export default __exports__